"use client";

import React, { useState } from "react";
import { MapPin, Search, Battery, BatteryFull, BatteryMedium, BatteryLow, Navigation, Zap } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
const locations = [{
  id: 1,
  name: "Central Station Hub",
  address: "Stationsplein 1, Amsterdam",
  distance: "0.2 km",
  available: 18,
  total: 24,
  status: "high",
  top: "35%",
  left: "48%"
}, {
  id: 2,
  name: "Café De Hoek",
  address: "Prinsengracht 45, Amsterdam",
  distance: "0.5 km",
  available: 4,
  total: 10,
  status: "medium",
  top: "55%",
  left: "35%"
}, {
  id: 3,
  name: "Dam Square Mall",
  address: "Dam 1, Amsterdam",
  distance: "0.8 km",
  available: 0,
  total: 12,
  status: "empty",
  top: "45%",
  left: "55%"
}, {
  id: 4,
  name: "Vondelpark Pavilion",
  address: "Vondelpark 1, Amsterdam",
  distance: "1.2 km",
  available: 8,
  total: 10,
  status: "high",
  top: "70%",
  left: "25%"
}, {
  id: 5,
  name: "Library Amsterdam",
  address: "Oosterdokskade 143, Amsterdam",
  distance: "1.5 km",
  available: 2,
  total: 8,
  status: "low",
  top: "25%",
  left: "65%"
}];
export default function FindAChargingStation() {
  const [activeLocation, setActiveLocation] = useState<number | null>(1);
  const getBatteryIcon = (status: string) => {
    switch (status) {
      case "high":
        return <BatteryFull className="w-5 h-5 text-primary" />;
      case "medium":
        return <BatteryMedium className="w-5 h-5 text-chart-4" />;
      case "low":
        return <BatteryLow className="w-5 h-5 text-destructive" />;
      default:
        return <Battery className="w-5 h-5 text-muted-foreground" />;
    }
  };
  const getStatusColor = (status: string) => {
    switch (status) {
      case "high":
        return "text-primary";
      case "medium":
        return "text-chart-4";
      case "low":
        return "text-destructive";
      default:
        return "text-muted-foreground";
    }
  };
  return <section id="vind-een-laadstation" className="relative w-full flex flex-col md:block h-[85vh] min-h-[600px] max-h-[900px] bg-background overflow-hidden border-y border-border">
      
      {}
      <div className="relative w-full h-[50vh] md:h-full bg-[#0f172a] overflow-hidden">
        {}
        <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: 'radial-gradient(#334155 1px, transparent 1px)',
        backgroundSize: '32px 32px'
      }} />
        
        {}
        <svg className="absolute inset-0 w-full h-full opacity-10 pointer-events-none" xmlns="http://www.w3.org/2000/svg">
          <path d="M-100 200 Q 300 100 500 400 T 1200 300" fill="none" stroke="#94a3b8" strokeWidth="20" strokeLinecap="round" />
          <path d="M200 -100 Q 400 300 300 600 T 400 1000" fill="none" stroke="#94a3b8" strokeWidth="12" strokeLinecap="round" />
          <path d="M600 -100 Q 500 400 800 500 T 1000 1000" fill="none" stroke="#94a3b8" strokeWidth="8" strokeLinecap="round" />
        </svg>

        {}
        <div className="absolute top-6 left-1/2 -translate-x-1/2 z-20 w-full max-w-md px-4 md:max-w-lg transition-all duration-300">
          <div className="flex items-center bg-background/80 backdrop-blur-xl border border-border/50 rounded-full p-1.5 shadow-lg shadow-black/10">
            <div className="pl-3 pr-2 text-muted-foreground">
              <Search className="w-5 h-5" />
            </div>
            <Input className="border-0 bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 px-2 text-base h-10 shadow-none" placeholder="Search for a venue or address..." />
            <Button size="icon" className="rounded-full shrink-0 h-10 w-10 bg-primary hover:bg-primary/90 text-primary-foreground">
              <Navigation className="w-4 h-4" />
            </Button>
          </div>
        </div>

        {}
        {locations.map((loc, i) => <div key={loc.id} data-index={i} className={`absolute transform -translate-x-1/2 -translate-y-full cursor-pointer transition-all duration-300 z-10 ${activeLocation === loc.id ? 'scale-110 z-20' : 'hover:scale-105'}`} style={{
        top: loc.top,
        left: loc.left
      }} onClick={() => setActiveLocation(loc.id)}>
            <div className="flex flex-col items-center group">
              {}
              <div className={`
                text-xs font-bold px-2.5 py-1 rounded-full mb-1.5 shadow-lg transition-colors
                ${loc.available > 0 ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'}
                ${activeLocation === loc.id ? 'ring-2 ring-white/50 ring-offset-2 ring-offset-[#0f172a]' : ''}
              `}>
                {loc.available} <span className="opacity-70 font-normal">/ {loc.total}</span>
              </div>
              
              {}
              <div className="relative">
                <MapPin className={`w-10 h-10 transition-colors ${loc.available > 0 ? 'text-primary' : 'text-muted-foreground'}`} fill="currentColor" />
                {}
                <div className="absolute top-[10px] left-1/2 -translate-x-1/2 w-3 h-3 bg-[#0f172a] rounded-full" />
                
                {}
                {loc.available > 0 && <div className="absolute inset-0 bg-primary/30 blur-xl rounded-full -z-10 animate-pulse" />}
              </div>
            </div>
          </div>)}
      </div>

      {}
      <div className="w-full md:absolute md:right-0 md:top-0 md:bottom-0 md:w-[420px] bg-background/95 backdrop-blur-2xl border-t md:border-t-0 md:border-l border-border flex flex-col z-30 h-[50vh] md:h-full shadow-2xl">
        
        {}
        <div className="p-6 border-b border-border/50 bg-background/50">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-primary/10 rounded-lg text-primary">
              <Zap className="w-5 h-5" />
            </div>
            <h2 className="text-2xl font-bold text-foreground tracking-tight">Nearest Stations</h2>
          </div>
          <p className="text-sm text-muted-foreground">
            Found {locations.length} <span className="text-[#ffe838]">Zap</span><span className="text-[#70cf70]">GO!</span> stations near your location.
          </p>
        </div>

        {}
        <div className="flex-1 overflow-y-auto p-4 space-y-3 custom-scrollbar">
          {locations.map((loc, i) => <div key={loc.id} data-index={i} onClick={() => setActiveLocation(loc.id)} className={`
                p-4 rounded-xl border transition-all duration-200 cursor-pointer
                ${activeLocation === loc.id ? 'bg-accent/50 border-primary shadow-sm' : 'bg-card border-border hover:border-primary/50 hover:shadow-sm'}
              `}>
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h3 className="font-semibold text-foreground text-base">{loc.name}</h3>
                  <p className="text-sm text-muted-foreground mt-0.5">{loc.address}</p>
                </div>
                <div className="text-xs font-medium bg-secondary/10 text-secondary-foreground px-2 py-1 rounded-md whitespace-nowrap">
                  {loc.distance}
                </div>
              </div>
              
              <div className="flex items-center justify-between pt-3 border-t border-border/50">
                <div className="flex items-center gap-2">
                  {getBatteryIcon(loc.status)}
                  <span className={`text-sm font-medium ${getStatusColor(loc.status)}`}>
                    {loc.available > 0 ? `${loc.available} Powerbanks available` : 'Currently empty'}
                  </span>
                </div>
                <Button variant={loc.available > 0 ? "default" : "secondary"} size="sm" className="h-8 text-xs" disabled={loc.available === 0}>
                  {loc.available > 0 ? 'Reserve' : 'Notify Me'}
                </Button>
              </div>
            </div>)}
        </div>
        
        {}
        <div className="p-4 border-t border-border/50 bg-muted/30">
          <Button variant="outline" className="w-full bg-background">
            View All Locations
          </Button>
        </div>
      </div>

    </section>;
}